export function getLauncherLatestURL() {
  const env = window._ENV || "local";
  const awsEnv = window._AWS_ENV || "local";
  if (env === "local" && !window._NGROK_HOST) {
    return undefined;
  } else if (awsEnv === "dev") {
    //Keep the same URL as we don't want to switch versions accidentally
    return window.location.href;
  }

  const queryParams = window.location.search ?? "";
  const match = new RegExp(/(.*\/launcher\/.*?)\/.*/g).exec(window.location.toString());
  if (match && match.length > 1) {
    return `${match[1]}/latest${queryParams}`;
  }
  return undefined;
}
